export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'fc1de02b-9ca1-4fcb-9f72-8d4f90e6f512';
export const MODAL_CLOSE_SEC = 2.5;
